import React, {Fragment} from 'react';
import {connect} from "dva";
import {routerRedux} from "dva/router";
import qs from 'qs';
import classnames from 'classnames';
import CheckUtil from "../../utils/check-util";
import CommonUtil from "./../../utils/common-util";
import RenderUtil from "../../utils/render-util";
import {LocalConst} from "../../utils/constant";
import StorageUtil from "../../utils/storage-util";
import CarouselFooter from "./home-floor/carouselFloor";
import ImageFooter from "./home-floor/imageFloor";
import GoodsFooter from "./home-floor/goodsFloor";
import RichTextFloor from "./home-floor/richTextFloor";
import {ShopFetch, SystemFetch} from "../../services/service";
import {message, Modal} from "antd";
import {injectIntl} from "react-intl";
import IMGNull from '../../assets/images/loading_bg_template.png'
import UrlUtil from "../../utils/url-config";
import GoodsListAction from "../../components/goods-list-action";
import ReceiveCoupon from "./receive-coupon";

@injectIntl
@connect(state => ({...state.appModel}))
class HomeRoute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowTips: true,
            visibleProduct: false,
            selectGoods: {}
        };
        this.isLogin = CommonUtil.isLogin();
        // 是否体验账号
        this.isExperience = StorageUtil.getItem(LocalConst.isExperience);
    }

    componentDidMount() {
        if (this.isLogin) {
            this.getShopUserInfoForHome()
        }
    }

    getShopUserInfoForHome = () => {
        SystemFetch.getShopUserInfoForHome(null, rs => {
            if (!rs.status) {
                message.error(rs.message)
            }
            if (rs.data.outHouseList) {
                rs.data.outHouseList.forEach(outList => {
                    if (outList.send_attachment_) {
                        outList.send_attachment_ = JSON.parse(outList.send_attachment_)
                    }
                })
            }
            this.setState({
                userData: rs.data
            })
        })
    };

    // 去收藏
    toCollect = () => {
        if (this.isLogin) {
            this.props.dispatch(routerRedux.push({pathname: '/collect/list'}));
        } else {
            RenderUtil.renderLoginModal.call(this.props.intl);
        }
    };
    toLight = () => {
        let newTab = window.open('about:blank');
        let targetHost = UrlUtil.getLightUrl();// 跳转域名
        newTab.location.href = `${targetHost}?companyId=${StorageUtil.getItem(LocalConst.companyId)}`;
    };
    toLogin = () => {
        RenderUtil.renderLoginModal.call(this.props.intl);
    };
    toLink = (target, name) => {
        if (typeof target === "undefined" || !target.type_) return;
        switch (target.type_) {
            case 8: //外部链接
                // if (!CheckUtil.isUrl(target.val_)) return;
                const newTab = window.open('about:blank');
                newTab.location.href = `${target.val_}`;
                break;
            case 11: // 收藏商品
                this.toCollect();
                break;
            case 29: // 去配灯
                this.toLight();
                break;
            case 33: // 家居定制
                this.toBitMap();
                break;
            default:
                const newLocation = CommonUtil.getDecorateLocation(target);
                const search = qs.stringify(newLocation.query);
                const path = `${newLocation.pathname}?${search}`;
                if (target.new_tab_) {
                    window.open(path, '_blank')
                } else {
                    this.setState({
                        keyword:''
                    });
                    this.props.history.push(path);
                }
        }
    };
    // 隐藏体验提升
    isHideTips = () => {
        this.setState({
            isShowTips: false
        }, () => {
            const loginUser = StorageUtil.getItem(LocalConst.mShop_user);
            loginUser.isShowExperienceTips = false;
            StorageUtil.setItem(LocalConst.mShop_user, loginUser);
        });
    };

    fillDefaultImage = (imgList, style_) => {
        if (imgList.length < style_) {
            for (let i = 0; i < style_ - imgList.length; i++) {
                imgList.push({
                    img_: IMGNull,
                    isDefaultCard: true
                }); // 上传图片小于排版数量时填充默认图片
            }
        }
        return imgList;
    };

    renderFloors = (item, index) => {
        const key = CommonUtil.uuid(8);
        switch (item.type_) {
            case 1:
                return <CarouselFooter key={key} toLink={this.toLink} data={item}/>;
            case 2:
                return <GoodsFooter key={key} data={item} showGoodsListAction={(event, goods) => this.showGoodsListAction(event, goods)}/>;
            case 3:
                const {imgs_ = [], style_} = item;
                let imgList = imgs_;
                if (style_ === 1 || style_ === 2 || style_ === 3) {
                    imgList = imgs_.slice(0, style_);
                    imgList = this.fillDefaultImage(imgList, style_);
                } else if (style_ === 4) {
                    imgList = imgs_.slice(0, 3);
                } else if (style_ === 5 || style_ === 6 || style_ === 8 || style_ === 10) {
                    imgList = imgs_.slice(0, style_ - 1);
                    imgList = this.fillDefaultImage(imgList, style_ - 1);
                } else {
                    imgList = imgs_.slice(0, style_);
                    imgList = this.fillDefaultImage(imgList, style_);
                }
                item.imgs_ = imgList;
                return <ImageFooter key={key} toLink={this.toLink} data={item}/>;
            case 4:
                return <RichTextFloor key={key} data={item}/>;
            default:
                return ''
        }
    };
    toBitMap = () => {
        SystemFetch.getOpenAuthCode().then(rs => {
            // let newTab = window.open('about:blank');
            let targetHost = UrlUtil.getBitMapUrl();// 跳转域名
            window.location.href = `${targetHost}?authCode=${rs.data}`;
        });

    };
    putAwaySwitch = () => {
        this.setState({
            putClose: !this.state.putClose
        })
    };

    goodsActionCancel = () => {
        this.setState({
            visibleProduct: false,
            selectGoods: {},
        });
    };

    showGoodsListAction = (event, goods) => {
        event.preventDefault();
        event.stopPropagation();
        if (goods) {
            //获取商品详情
            ShopFetch.getGoodsById(goods.id_, (rs) => {
                if (rs.status === 1) {
                    rs.data.productList.forEach(product => {
                        product.cart_number_ = 0;
                        product.realPrice = product.client_price_;
                        product.enableStock = product.house_enable_stock_;
                        product.number_scale_ = 1;
                        product.unit_text_ = rs.data.unit_name_;
                    });
                    this.setState({
                        visibleProduct: true,
                        selectGoods: rs.data,
                    });
                }
            });
        }
    };

    render() {
        const {visibleProduct, selectGoods} = this.state;
        const {homeFloors, intl} = this.props;
        const {putClose} = this.state;
        return <Fragment>
            <section className="page-floor">
                {
                    (homeFloors || []).map((floor, index) => {
                        switch (floor.type_) {
                            case 1:
                            case 2:
                                const cls = classnames({
                                    "floor-max-box": floor.type_ === 1,
                                    "floor-middle-box": floor.type_ === 2,
                                });
                                return (
                                    <div className={cls} key={index}>
                                        {
                                            floor.content_.map((item, cIndex) => {
                                                return this.renderFloors(item, cIndex)
                                            })
                                        }
                                    </div>
                                );
                            case 3:
                            case 4:
                                const leftCls = classnames({
                                    "layout-little-box": floor.type_ === 3,
                                    "layout-large-box": floor.type_ === 4,
                                });
                                const rightCls = classnames({
                                    "layout-large-box": floor.type_ === 3,
                                    "layout-little-box": floor.type_ === 4,
                                });
                                return (
                                    <div className='floor-grail-layout' key={index}>
                                        <div className={leftCls}>
                                            {
                                                floor.content_1_.map((item, cIndex) => {
                                                    return this.renderFloors(item, cIndex)
                                                })
                                            }
                                        </div>
                                        <div className={rightCls}>
                                            {
                                                floor.content_2_.map((item, cIndex) => {
                                                    return this.renderFloors(item, cIndex)
                                                })
                                            }
                                        </div>
                                    </div>
                                );
                            default:
                                return null;
                        }
                    })
                }
            </section>

            {
                this.isExperience &&
                <div className={putClose ? 'switcher-right-box' : 'switcher-box'}>
                    <div className="close-btn" role={'none'} onClick={this.putAwaySwitch}><i className="iconfont icon-cancel"/></div>
                    <h2>你正在体验订货端</h2>
                    <div className="btn-box">
                        {
                            putClose &&
                            <button className="switch-btn" onClick={this.putAwaySwitch}>
                                <i className="iconfont icon-return"/>
                            </button>
                        }
                        <button className="switch-btn" onClick={CommonUtil.toMgrExperience}>
                            <i className="iconfont icon-switch" title="切换到管理端"/>切换到管理端
                        </button>
                        <button className="switch-btn" onClick={CommonUtil.toCompanyRegister} ng-click="toRegister()">
                            <i className="iconfont icon-user" title="注册正式账号"/>注册正式账号
                        </button>
                    </div>
                </div>
            }


            <Modal
                title={intl.messages.HYNTYYSDH || '欢迎您体验云上订货'}
                visible={this.isExperience && this.state.isShowTips}
                footer={null}
                width={400}
            >

                <div className="pop-experience-tips">
                    <p><i
                        className="iconfont icon-dialog_box_icon_plai"/>{intl.messages.TYZHSJHDQG || '体验账号数据会定期更新，请勿输入重要信息'}！
                    </p>
                    <p><i
                        className="iconfont icon-dialog_box_icon_plai"/>{intl.messages.TYZHZDNRSJ || '体验账号中的内容数据均为虚构，请勿输入重要信息'}！
                    </p>
                    <button className="btn"
                            onClick={this.isHideTips}>{intl.messages.WoZhiDaoLe || '我知道了'}</button>
                </div>
            </Modal>

            {/*领取优惠券*/}
            <ReceiveCoupon/>

            {/* 规格选框 */}
            {
                visibleProduct &&
                <GoodsListAction
                    visible={visibleProduct}
                    goods={selectGoods}
                    history={this.props.history}
                    onCancel={this.goodsActionCancel}
                    addToCart={this.addToCart}
                />
            }

        </Fragment>
    }
}


export default HomeRoute;
